import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import VerifiedBadge from "../common/components/VerifiedBadge";
import { findVnodeByClass } from "./utils/vnodeTree";

/**
 * Add the verified badge as its own item in the post header item list, and
 * to the live reply preview.
 */
export default function addBadgeToCommentPost() {
  extend("flarum/forum/components/CommentPost", "headerItems", function (items) {
    const post = this.attrs.post;
    const user = post && post.user && post.user();
    if (!user || !user.isVerified || !user.isVerified()) return;
    items.add("verified", m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--post"
    }), 95);
  });

  // The live reply preview (core's ReplyPlaceholder, `<article class="Post
  // CommentPost editing">`) builds its header straight from <PostUser>, so it
  // never goes through `headerItems` above. Add the badge next to it.
  extend("flarum/forum/components/ReplyPlaceholder", "view", function (vnode) {
    if (!vnode || vnode.tag !== "article") return;
    const user = app.session.user;
    if (!user || !user.isVerified || !user.isVerified()) return;
    const header = findVnodeByClass(vnode, "Post-header");
    if (!header || !Array.isArray(header.children)) return;

    // Same wrapper as a real post (`ul > li.item-verified`), so the
    // header's baseline alignment and the <li> spacing apply unchanged.
    header.children = [...header.children, m("ul", null, m("li", {
      className: "item-verified"
    }, m(VerifiedBadge, {
      user: user,
      className: "VerifiedBadge--post"
    })))];
  });
}